import { render, staticRenderFns } from "./cv-list-item.vue?vue&type=template&id=68c49811&"
import script from "./cv-list-item.vue?vue&type=script&lang=js&"
export * from "./cv-list-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports